import * as React from "react";
import RestrictedComponent, { RestrictedComponentProps } from "./RestrictedComponent";
import { ApplicationState } from "../../store";
import { connect } from "react-redux";
import { PermissionEnum } from "../../models";

interface RequirePermissionProps {
    permissions?: PermissionEnum[]
    allowIfProfessional?: boolean
    children: React.ReactElement
    notPermitted?: React.ReactElement
}

export const RequirePermission = connect<RestrictedComponentProps, void, RequirePermissionProps, ApplicationState>(
    (state: ApplicationState, ownProps: RequirePermissionProps): RestrictedComponentProps => ({
        isLoggedIn: !!state.session.user,
        hasPermission: 
            !state.session.user?.isClient && (
                (ownProps.allowIfProfessional && !!state.session.user?.professionalId) || 
                !ownProps.permissions?.length || state.session.user?.permissions?.some(up => ownProps.permissions?.includes(up))
            ) || false,
        children: ownProps.children,
        notPermitted: ownProps.notPermitted,
    }),
    undefined,
)(RestrictedComponent as any);

export interface SpecificRequireProps {
    children: React.ReactElement,
    notPermitted?: React.ReactElement;
}

export const RequireLogin = connect<RestrictedComponentProps, void, SpecificRequireProps, ApplicationState>(
    (state: ApplicationState, ownProps: SpecificRequireProps): RestrictedComponentProps => ({
        isLoggedIn: !!state.session.user,
        hasPermission: !!state.session.user,
        children: ownProps.children,
        notPermitted: ownProps.notPermitted,
    }),
    undefined,
)(RestrictedComponent as any);

export const RequireLogout = connect<RestrictedComponentProps, void, SpecificRequireProps, ApplicationState>(
    (state: ApplicationState, ownProps: SpecificRequireProps): RestrictedComponentProps => ({
        isLoggedIn: true,
        hasPermission: !state.session.user,
        children: ownProps.children,
        notPermitted: ownProps.notPermitted,
    }),
    undefined,
)(RestrictedComponent as any);

export const RequireAdministrator = (props: SpecificRequireProps) => 
    (<RequirePermission {...props} permissions={[
        PermissionEnum.Administrator
    ]}/>);

export const RequireClientsManagement = (props: SpecificRequireProps) => 
    (<RequirePermission {...props} permissions={[
        PermissionEnum.Administrator,
        PermissionEnum.ClientsAccess,
        PermissionEnum.ClientsManagement,
    ]}/>);

export const RequireAppointmentsManagement = (props: SpecificRequireProps) => 
    (<RequirePermission {...props} permissions={[
        PermissionEnum.Administrator,
        PermissionEnum.AppointmentsManagement,
    ]}/>);

export const RequireProfessionalsManagement = (props: SpecificRequireProps) => 
    (<RequirePermission {...props} permissions={[
        PermissionEnum.Administrator,
        PermissionEnum.ProfessionalsManagement,
    ]}/>);

export const RequirePricesManagement = (props: SpecificRequireProps) => 
    (<RequirePermission {...props} permissions={[
        PermissionEnum.Administrator,
        PermissionEnum.PricesManagement,
    ]}/>);    

export const RequireAnalyticsPermission = (props: SpecificRequireProps) => 
    (<RequirePermission {...props} allowIfProfessional permissions={[
        PermissionEnum.Administrator,
        PermissionEnum.Analytics,
    ]}/>);    

export const RequireCampaignManagement = (props: SpecificRequireProps) => 
    (<RequirePermission {...props} permissions={[
        PermissionEnum.Administrator,
        PermissionEnum.CampaignsManagement,
    ]}/>);    